import script from "./CampaignCallHistoryPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignCallHistoryPanel.vue?vue&type=script&setup=true&lang=js"

import "./CampaignCallHistoryPanel.vue?vue&type=style&index=0&id=f604635e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f604635e"]])

export default __exports__